<template>
	<div class="cm-wrapper cm-wrapper-details">
		<details-error v-if="error === 'carNotFound'"></details-error>
		<template v-else-if="ready && car && refData">
			<div class="cm-detail-content">
				<div class="amd-section cm-detail-intro pt-0 pt-sm-4">
					<div class="container">
						<div class="row gx-4 row-intro">
							<div class="col-xl-8 col-lg-7 col-md-12 col-sm-12 col-12">
								<WebPlayer
									id="carcutter-webplayer"
									:compositionUrl="getCarcutterWebplayUrl()"
									:infiniteCarrousel="true"
									:permanentGallery="true"
									:reverse360="true"
									:autoLoad360="true"
									:demoSpin="true"
									@compositionLoaded="carcutterCompositionLoaded($event)"
									@compositionLoadError="carcutterCompositionLoadError($event)"
									@compositionLoading="
										(url) => console.log('Composition loading: ', url)
									"
								/>

								<details-images :car="car" class="mb-4" id="darmas-gallery" />
							</div>
							<div
								class="col-xl-4 col-lg-5 col-md-12 col-sm-12 col-xs-12 col-12"
							>
								<div class="d-flex flex-column h-100">
									<div class="">
										<h3 class="title d-lg-none d-xl-block mb-3">
											{{ carTitle }}
										</h3>
										<details-pricing :car="car" :title="carTitle" />
									</div>
									<div class="mt-auto pb-3 intro-features">
										<table class="table table-features">
											<tbody>
												<tr>
													<td class="label">Angebots-Nr.</td>
													<td>
														{{ car.ad.internalNumber }}
													</td>
												</tr>
												<tr>
													<td class="label">Zustand</td>
													<td>
														{{
															car.displayAd.usageType ?? car.displayAd.condition
														}}
													</td>
												</tr>
												<tr>
													<td class="label">Krafstoffart</td>
													<td>{{ car.displayAd.fuel }}</td>
												</tr>
												<tr>
													<td class="label">Getriebe</td>
													<td>{{ car.displayAd.gearbox }}</td>
												</tr>
												<tr>
													<td class="label">Motorleistung</td>
													<td>
														{{ car.ad.power }} kW ({{ getCarPs(car.ad.power) }}
														Ps)
													</td>
												</tr>
												<template
													v-if="car.ad.mileage > 0 && car.ad.firstRegistration"
												>
													<tr>
														<td class="label">Kilometerstand</td>
														<td>
															{{ getPrice(car.ad.mileage) + ' Km' }}
														</td>
													</tr>
													<tr>
														<td class="label border-bottom-0">Erstzulassung</td>
														<td class="border-bottom-0">
															{{
																getFirstRegistrationDate(
																	car.ad.firstRegistration
																)
															}}
														</td>
													</tr>
												</template>
											</tbody>
										</table>
										<div class="mb-2 mt-2">
											<div class="row g-2">
												<div class="col-md-4">
													<button
														v-if="
															this.$store.state.user.bookmarks.cars[car._id] !==
															undefined
														"
														class="btn btn-block btn-outline-primary"
														type="button"
														@click.prevent="
															this.removeCarFromBookmarks(car._id)
														"
													>
														<i class="mdi mdi-star"></i>
														Gemerkt
													</button>
													<button
														v-else
														class="btn btn-block btn-white"
														type="button"
														@click.prevent="this.addCarToBookmarks(car)"
													>
														<i class="mdi mdi-star-outline"></i>
														Merken
													</button>
												</div>
												<div class="col-md-4">
													<a
														class="btn btn-white btn-block"
														target="_blank"
														:href="
															'https://mobile.dispo24.de:8031/v1/mobile-de/create/darmasad/pdf/internalNumber/' +
															car.ad.internalNumber
														"
													>
														<i class="mdi mdi-download"></i>
														PDF
													</a>
												</div>
												<div class="col-md-4">
													<button
														type="button"
														data-bs-toggle="modal"
														data-bs-target="#modalShareCar"
														class="btn btn-block btn-white"
													>
														<i class="mdi mdi-share-variant-outline"></i> Teilen
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="amd-section pt-4 cm-detail-body">
					<div class="container">
						<div class="row gx-4 justify-content-center">
							<div class="col-xl-8 col-lg-7 col-md-12 col-sm-12 mb-4">
								<div class="cm-car-features car-features h-100">
									<div class="card card-car h-100">
										<div class="card-header p-0 bg-white card-header-nav">
											<ul class="nav nav-tabs">
												<li class="nav-item">
													<a
														class="nav-link"
														:class="{ active: detailView === 'description' }"
														href="#"
														@click.prevent="detailView = 'description'"
														>Beschreibung</a
													>
												</li>
												<li class="nav-item">
													<a
														class="nav-link"
														:class="{ active: detailView === 'features' }"
														href="#"
														@click.prevent="detailView = 'features'"
														>Ausstattung</a
													>
												</li>
											</ul>
										</div>
										<template v-if="detailView === 'features'">
											<details-features
												:ref-data="refData"
												:car="car"
											></details-features>
										</template>
										<template v-else>
											<details-description
												:car-internal-number="car.ad.internalNumber"
												:car-description="car.ad.description"
												:delivery-date="car.ad.deliveryDate"
												:delivery-period="car.ad.deliveryPeriod"
											></details-description>
										</template>
									</div>
								</div>
							</div>
							<div class="col-xl-4 col-lg-5 col-md-12 col-sm-12 mb-4">
								<details-card-features-extra
									class="mb-4"
									:car="car"
									:ref-data="refData"
								/>
								<!-- v-if="car.ad.consumptionCombined" -->
								<div
									class="card card-car card-car-verbrauch mb-4"
									v-if="car.ad.consumptions"
								>
									<div class="card-body">
										<h5 class="card-title">Verbrauch & Umwelt</h5>
										<table class="table-features table mb-0">
											<template v-if="car.displayAd.fuel === 'Elektro'">
												<tr>
													<td class="label" style="width: 45%">
														Verbr. kombiniert<sup>4</sup>
													</td>
													<td>
														{{ car.ad.consumptions.power.combined }} kWh/100km
													</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.power.city &&
														car.ad.consumptions.power.city !== ''
													"
												>
													<td class="label">Verbr. City<sup>4</sup></td>
													<td>{{ car.ad.consumptions.power.city }} l/100km</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.power.suburban &&
														car.ad.consumptions.power.suburban !== ''
													"
												>
													<td class="label">Verbr. Vorstadt<sup>4</sup></td>
													<td>
														{{ car.ad.consumptions.power.suburban }} l/100km
													</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.power.rural &&
														car.ad.consumptions.power.rural !== ''
													"
												>
													<td class="label">Verbr. Landstraße<sup>4</sup></td>
													<td>{{ car.ad.consumptions.power.rural }} l/100km</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.power.highway &&
														car.ad.consumptions.power.highway !== ''
													"
												>
													<td class="label">Verbr. Autobahn<sup>4</sup></td>
													<td>
														{{ car.ad.consumptions.power.highway }} l/100km
													</td>
												</tr>
												<tr>
													<td class="label">CO2-Emission</td>
													<td>0 g/km</td>
												</tr>
												<tr>
													<td class="label">CO2-Klasse</td>
													<td>A</td>
												</tr>
											</template>
											<template v-else>
												<tr>
													<td class="label">Verbr. kombiniert<sup>4</sup></td>
													<td>
														{{ car.ad.consumptions.fuel.combined }} l/100km
													</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.fuel.city &&
														car.ad.consumptions.fuel.city !== ''
													"
												>
													<td class="label">Verbr. City<sup>4</sup></td>
													<td>{{ car.ad.consumptions.fuel.city }} l/100km</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.fuel.suburban &&
														car.ad.consumptions.fuel.suburban !== ''
													"
												>
													<td class="label">Verbr. Vorstadt<sup>4</sup></td>
													<td>
														{{ car.ad.consumptions.fuel.suburban }} l/100km
													</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.fuel.rural &&
														car.ad.consumptions.fuel.rural !== ''
													"
												>
													<td class="label">Verbr. Landstraße<sup>4</sup></td>
													<td>{{ car.ad.consumptions.fuel.rural }} l/100km</td>
												</tr>
												<tr
													v-if="
														car.ad.consumptions.fuel.highway &&
														car.ad.consumptions.fuel.highway !== ''
													"
												>
													<td class="label">Verbr. Autobahn<sup>4</sup></td>
													<td>
														{{ car.ad.consumptions.fuel.highway }} l/100km
													</td>
												</tr>
												<tr v-if="car.ad.emissions?.combined?.co2">
													<td class="label">CO2-Emission</td>
													<td>{{ car.ad.emissions.combined.co2 }} g/km</td>
												</tr>
											</template>
											<tr
												v-if="
													car.displayAd.emissionClass &&
													car.displayAd.emissionClass !== ''
												"
											>
												<td class="label">Schadstoffklasse</td>
												<td>{{ car.displayAd.emissionClass }}</td>
											</tr>
											<tr
												v-if="
													car.displayAd.emissionSticker &&
													car.displayAd.emissionSticker !== ''
												"
											>
												<td class="label">Feinstaubplakette</td>
												<td>{{ car.displayAd.emissionSticker }}</td>
											</tr>
											<tr
												v-if="
													car.displayAd.energyEfficiencyClass &&
													car.displayAd.energyEfficiencyClass !== ''
												"
											>
												<td class="label">Effizienzklasse</td>
												<td>{{ car.displayAd.energyEfficiencyClass }}</td>
											</tr>
										</table>
									</div>
								</div>

								<div
									class="card card-car card-car-verbrauch mb-4"
									v-if="car.ad.costModel?.co2Costs"
								>
									<div class="card-body">
										<h5 class="card-title">Kosten Modell</h5>
										<table class="table-features table mb-0">
											<tr>
												<td class="label" style="width: 45%">KFZ Steuer</td>
												<td>{{ car.ad.costModel.tax }} €/Jahr</td>
											</tr>
											<tr>
												<td class="label" colspan="2">
													Mögliche CO₂-Kosten der nächsten 10 Jahre (15.000
													km/Jahr). Drei Kalkulationen auf Basis der folgenden
													Preisschätzungen:
												</td>
											</tr>

											<tr>
												<td class="label">Niedrig</td>
												<td>
													{{ car.ad.costModel.co2Costs.low.basePrice }} €/t
													&#8594;
													{{ car.ad.costModel.co2Costs.low.accumulated }} €
												</td>
											</tr>
											<tr>
												<td class="label">Mittel</td>
												<td>
													{{ car.ad.costModel.co2Costs.middle.basePrice }}
													€/t &#8594;
													{{ car.ad.costModel.co2Costs.middle.accumulated }} €
												</td>
											</tr>
											<tr>
												<td class="label">Hoch</td>
												<td>
													{{ car.ad.costModel.co2Costs.high.basePrice }}
													€/t &#8594;
													{{ car.ad.costModel.co2Costs.high.accumulated }} €
												</td>
											</tr>
										</table>
									</div>
								</div>

								<div
									v-if="car.displayAd.energyEfficiencyClass"
									class="card card-car card-co2"
								>
									<div class="card-body">
										<h5 class="card-title">CO2-Effizienz</h5>
										<details-co2-efficiency
											:efficiency="car.ad.energyEfficiencyClass"
										></details-co2-efficiency>
										<p class="text-muted font-14 mt-3 mb-0">
											Auf der Grundlage der gemessenen CO₂-Emissionen unter
											Berücksichtigung der Masse des Fahrzeugs ermittelt.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="amd-section cm-detail-contact" id="card-contact">
					<div class="container">
						<div class="row gx-4">
							<div class="col-xl-8 col-lg-7 col-md-12 col-sm-12 col-12 mb-4">
								<div class="card card-car">
									<div class="card-body">
										<h5 class="card-title">Anfrage für {{ carTitle }}</h5>

										<details-request-form
											v-if="car.status.online"
											:price="price"
											:car="car"
											:car-title="carTitle"
											:store="store"
										/>
									</div>
								</div>
							</div>
							<div
								class="col-xl-4 col-lg-5 col-md-12 col-sm-12 col-xs-12 col-12 mb-4"
							>
								<div class="card card-car h-100">
									<div class="card-body p-0">
										<details-contact-store :store="store" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<details-mobile-toolbar :car="car" :car-title="carTitle" />
			<details-modal-share-car :car="car" />
		</template>
	</div>
</template>

<script>
import DarmasApiService from '@/services/DarmasApiService'
import DetailsFeatures from '@/components/details/DetailsFeatures'
import DetailsCo2Efficiency from '@/components/details/DetailsCo2Efficiency'
import DetailsPricing from '@/components/details/DetailsPricing'
import DetailsContactStore from '@/components/details/DetailsContactStore'
import DetailsDescription from '@/components/details/DetailsDescription'
import store from '@/store'
import DetailsError from '@/components/details/DetailsError'
import DetailsImages from '@/components/details/DetailsImages'
import DetailsRequestForm from '@/components/details/DetailsRequestForm'
import DetailsMobileToolbar from '@/components/details/DetailsMobileToolbar'
import DetailsModalShareCar from '@/components/details/DetailsModalShareCar'
import DetailsCardFeaturesExtra from '@/components/details/DetailsCardFeaturesExtra'

import { generateCompositionUrl } from '@car-cutter/vue-webplayer'

import { WebPlayer } from '@car-cutter/vue-webplayer'

export default {
	name: 'DetailView',
	components: {
		DetailsImages,
		DetailsDescription,
		DetailsFeatures,
		DetailsCo2Efficiency,
		DetailsMobileToolbar,
		DetailsRequestForm,
		DetailsCardFeaturesExtra,
		DetailsContactStore,
		DetailsPricing,
		DetailsModalShareCar,
		DetailsError,
		WebPlayer,
	},
	props: {
		carData: Object,
		refData: Object,
		firstInit: Boolean,
	},
	data() {
		return {
			ready: false,
			loading: true,
			error: '',
			urlImgUser: 'images/ansprechpartner/',
			price: {
				view: 'fixed',
				minRate: 0,
				maxRate: 0,
				financing: {
					period: 60,
					deposit: 0,
				},
				leasing: {
					period: 48,
					deposit: 0,
					mileage: 10000,
				},
			},
			carouselSetting: {
				settings: {
					lazyLoad: 'ondemand',
					dots: true,
					fade: true,
					infinite: true,
					speed: 500,
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			car: {},
			carTitle: '',
			carImages: {},
			store: {},
			selectedLeasing: {},
			detailView: 'description',
			// carcutterWebplayerUri: '',
		}
	},
	computed: {
		isBookmarked() {
			return store.state.user.bookmarks.cars[this.car._id] === undefined
		},
	},
	methods: {
		getSelectedLeasing(event) {
			this.selectedLeasing = event.response
		},
		getCarcutterWebplayUrl() {
			let testCar = 'TESTTEST16'

			// const testCounter = Math.floor(Math.random() * 4)

			// // if (testCounter === 0) {
			// // 	testCar = this.car.ad.vin
			// // } else if (testCounter === 1) {
			// // 	testCar = 'TESTTEST16'
			// // } else if (testCounter === 2) {
			// // 	testCar = 'TESTTEST17'
			// // } else {
			// // 	testCar = 'TESTTEST15'
			// // }

			// console.log('testCounter', testCounter, testCar)

			// if (this.car.internalNumber === 'TESTTEST18') {
			// 	testCar = 'TESTTEST16'
			// } else if (this.car.internalNumber === 'TESTTEST17') {
			// 	testCar = 'TESTTEST17'
			// } else if (this.car.internalNumber === 'TESTTEST15') {
			// 	testCar = 'TESTTEST15'
			// } else {
			// 	testCar = this.car.ad.vin
			// }

			testCar = '2105431716'
			if (this.car.ad.internalNumber === '2105443368') {
				testCar = this.car.ad.vin
			} else {
				testCar = this.car.ad.internalNumber
			}

			console.log('testCar', testCar)

			const uri = generateCompositionUrl(
				// 'b0faff392bbf835e162314979d2d2b937f7b9ef7654d123a9951212bd03f83f7', // sha-256 hash custom id
				'7cdb31edeb522f0b916b9b638ae9778bd9c0c0ea5519d10606afa020a00d8fc1', // customer id as sha-256 hash
				testCar
			)

			console.log('uri::', uri)

			return uri
		},
		carcutterCompositionLoaded($event) {
			console.log('carcutterCompositonLoaded', $event)
			document.getElementById('carcutter-webplayer').style.display = 'block'
			document.getElementById('darmas-gallery').style.display = 'none'
		},
		carcutterLoadError(event) {
			console.log('carcutterLoadError', event)
		},
		carcutterCompositionLoadError($event) {
			console.log('carcutterCompositionLoadError', $event)

			document.getElementById('carcutter-webplayer').style.display = 'none'
			document.getElementById('darmas-gallery').style.display = 'block'

			// remove carcutter webplayer and show our image viewer
		},
	},
	mounted() {},
	created() {
		const carId = this.$route.params.id

		if (!carId) {
			this.error = 'carNotFound'
		} else {
			this.error = ''
		}

		if (store.state.user.token === '') {
			DarmasApiService.getFormToken()
				.then((response) => {
					store.commit('setFormToken', response.data.token)
				})
				.catch((error) => {
					console.log(error)
				})
		}

		if (this.carData) {
			this.car = this.carData
			const title =
				this.refData[this.car.ad.make] + ' ' + this.car.ad.modelDescription
			this.carTitle = title
			DarmasApiService.setMetaData(title, title)
		} else {
			DarmasApiService.getItem(carId)
				.then((response) => {
					const data = response.data
					this.car = data
					return DarmasApiService.getStoreData(data.store.alias)
				})
				.then((response) => {
					const title =
						this.refData[this.car.ad.make] + ' ' + this.car.ad.modelDescription
					this.carTitle = title
					DarmasApiService.setMetaData(title, title)
					this.store = response.data
					this.ready = true
					this.loading = false
				})
				.catch((error) => {
					if (error !== undefined) {
						console.log(error.response)
					}
					console.log(error)
				})
		}
	},
}
</script>

<style lang="scss">
.cm-wrapper-details {
	background-color: rgb(241 241 241);
}
.cm-detail-top {
	//background-color: $lightest;
	border-bottom-left-radius: 1rem;
	border-bottom-right-radius: 1rem;
}
.cm-detail-intro {
	background: #fff;
	//box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
	.title {
		font-weight: 600;
		font-family: $font-family-base;
	}
}

.cm-wrapper-details {
	.card {
		@include media-breakpoint-up(lg) {
			.card-body {
				padding: 1.5rem;
			}
		}
		.card-title {
			font-weight: 600;
			font-family: $font-family-base;
		}
	}
}

.table-features {
	tr {
		td {
			border-bottom: 1px $border-color dotted;
			padding: $px5 $px6;
			vertical-align: middle;
			&.label {
				padding-left: 2px;
				color: $gray-600;
				font-size: $px14;
			}
		}
		&:last-of-type {
			td {
				border-bottom-color: transparent;
			}
		}
	}
}

.detail-header {
	font-size: $px24;
}

.cm-detail-contact {
	background-color: #f1f1f1;
	box-shadow: none;
}
.intro-features {
	label {
		font-size: $px14;
		font-weight: 400;
		color: $gray-600;
	}
	span {
		font-size: $px16;
		display: block;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		width: 100%;
	}
}
</style>
